import { Tabs } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

export const StyledTabsList = styled(Tabs.List, {
  base: {
    zIndex: 100000,
    position: 'sticky',
    top: 'spacing.-400',
    backgroundColor: 'bg.neutral',
  },
});

export const StyledTab = styled(Tabs.Tab, {
  base: {
    textStyle: { base: 'body-xs', sm: 'body-sm', md: 'body' },
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    '&[aria-selected="false"]': {
      justifyContent: 'center',
    },
    '&[aria-selected="true"]': {
      justifyContent: 'center',
    },
  },
});
